import React, { useMemo } from 'react';
import cx from 'classnames';
import '../../../../layout/Layout/Context/index.js';
import '../../../../layout/Layout/ScrollView/index.js';
import '../../../../layout/Layout/View/index.js';
import '../../../../layout/Layout/View/components/ToolbarWrapper/index.js';
import '../../../../layout/Layout/View/components/SearchWrapper/index.js';
import '../../../../layout/Layout/View/components/HeaderCenterWrapper/index.js';
import { useWindowSize } from '../../../../../utils/hooks/useWindowSize.js';
import styles from './index.module.scss.js';
import { useLayoutContext } from '../../../../layout/Layout/Context/utils/useLayoutContext.js';

const GRow = ({
  className,
  style,
  children,
  animations = {
    "data-aos": "fade-up-sm",
    "data-aos-delay": "200",
    "data-aos-duration": "1000"
  }
}) => /* @__PURE__ */ React.createElement("div", { className: cx(styles.row, className), style, ...animations }, children);
GRow.displayName = "GamingPanel.GRow";
const GPanel = ({
  opacity,
  className,
  style,
  children
}) => {
  const { contentWidth } = useLayoutContext();
  const { windowSize } = useWindowSize();
  const isNeedMobile = useMemo(
    () => contentWidth < 1e3 || windowSize.width <= 1024,
    [contentWidth, windowSize]
  );
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cx(styles.box, className, {
        [styles["mobile-styles"]]: isNeedMobile
      }),
      style: {
        ...style,
        "--panel-opacity": opacity ? "0.6" : "1"
      }
    },
    children
  );
};
GPanel.displayName = "GamingPanel.GPanel";
const GCol = ({
  className,
  style,
  children
}) => /* @__PURE__ */ React.createElement("div", { className: cx(styles.col, className), style }, children);
GCol.displayName = "DashboardPanel.GCol";
const GTitle = ({
  className,
  style,
  children,
  animations = {
    "data-aos": "fade-up-sm",
    "data-aos-delay": "100",
    "data-aos-duration": "1000"
  }
}) => /* @__PURE__ */ React.createElement("div", { className: cx(styles.title, className), style, ...animations }, children);
const GText = ({
  className,
  style,
  children,
  animations = {
    "data-aos": "fade-up-sm",
    "data-aos-delay": "200",
    "data-aos-duration": "1000"
  }
}) => /* @__PURE__ */ React.createElement("div", { className: cx(styles.text, className), style, ...animations }, children);
const CooldownPanel = ({
  className,
  style,
  children,
  animations = {
    "data-aos": "fade-up-sm",
    "data-aos-delay": "200",
    "data-aos-duration": "1000"
  }
}) => /* @__PURE__ */ React.createElement(
  "div",
  {
    className: cx(styles["cooldown-panel"], className),
    style,
    ...animations
  },
  children
);
CooldownPanel.displayName = "GamingPanel.CooldownPanel";
const GGPanel = ({
  className,
  style,
  children,
  animations = {
    "data-aos": "fade-up-sm",
    "data-aos-delay": "200",
    "data-aos-duration": "1000"
  }
}) => /* @__PURE__ */ React.createElement("div", { className: cx(styles.panel, className), style, ...animations }, children);
GPanel.displayName = "GamingPanel.GGPanel";
const PanelTitle = ({ className, style, children }) => /* @__PURE__ */ React.createElement("div", { className: cx(styles["panel-title"], className), style }, children);
PanelTitle.displayName = "GamingPanel.PanelTitle";
const PanelText = ({ className, style, children }) => /* @__PURE__ */ React.createElement("div", { className: cx(styles["panel-text"], className), style }, children);
PanelText.displayName = "GamingPanel.PanelText";

export { CooldownPanel, GCol, GGPanel, GPanel, GRow, GText, GTitle, PanelText, PanelTitle };
//# sourceMappingURL=index.js.map
